import React from 'react';
import { ComponentType } from '@philips-internal/oswald-ui-core';
import { HeadingType } from '../components/heading/heading-constants.js';
import { Heading } from '../components/heading/heading.js';
import { HeadingActions } from '../components/heading-actions/heading-actions.js';
import { HeadingContext, HeadingProvider } from '../components/heading-context/heading-context.js';
import { HeadingDynamicContent } from '../components/heading-dynamic-content/heading-dynamic-content.js';
import { HeadingTitle } from '../components/heading-title/heading-title.js';
import { ContextualBarProperties } from './contextual-bar-types.js';
import './contextual-bar.css';
const headerAcceptedTypes = [
    ComponentType.NAVIGATION,
];
class InternalContextualBar extends Heading {
    render() {
        const { inlineActionsDesktopLimit = ContextualBarProperties.inlineActionsDesktopLimit.defaultValue, uuid = ContextualBarProperties.uuid.defaultValue, } = this.props;
        return (React.createElement("section", { "aria-labelledby": `${this.context?.getIdentifier()}-heading__title`, className: this.getClassName('c-contextual-bar') },
            React.createElement("div", { className: "c-contextual-bar__header" },
                React.createElement("div", { className: "c-contextual-bar__header-top" },
                    React.createElement(HeadingTitle, null),
                    React.createElement(HeadingActions, { acceptedTypes: headerAcceptedTypes, inlineLimit: inlineActionsDesktopLimit, uuid: uuid })),
                React.createElement("div", { className: "c-contextual-bar__header-bottom" },
                    React.createElement(HeadingDynamicContent, null))),
            this.renderChildren('c-contextual-bar__content')));
    }
}
InternalContextualBar.contextType = HeadingContext;
function ContextualBar(props) {
    return (React.createElement(HeadingProvider, { type: HeadingType.CONTEXTUAL_BAR },
        React.createElement(InternalContextualBar, { ...props })));
}
export { ContextualBar, };
//# sourceMappingURL=contextual-bar.js.map